<template>
    <div class="bg-blue-400 border-2 border-dashed border-white font-light px-20 py-10 rounded text-center text-white text-xl w-full relative"
         @dragenter.prevent="onDragEnter"
         @dragleave.prevent="onDragLeave"
         @dragover.prevent
         @drop.prevent.stop="onDrop"
         :class="{dragging: isDragging}"
    >
        <div class="absolute w-full bg-white top-0 left-0 rounded-t-lg p-6 pb-4 text-right"
             v-show="images.length"
        >
            <div class="upload-control">
                <label for="file">Seleziona un file</label>
                <button @click="upload" :class="{loader: loading}">Upload</button>
            </div>
        </div>

        <div v-show="!images.length" class="wrapper">
            <i class="fas fa-cloud-upload-alt fa-7x"></i>
            <p>Trascina le tue immagini qui</p>
            <div>oppure</div>
            <div class="w-1/3 mx-auto flex flex-col relative">
                <label for="file">Seleziona un file</label>
                <input
                        type="file"
                        id="file"
                        multiple
                        @change="onInputChange"
                >
            </div>
        </div>
        <div class="flex flex-wrap mt-20"
             v-show="images.length"
        >
            <div class="flex flex-col bg-white text-blue-400 w-1/4 justify-between shadow-lg m-4"
                 v-for="(image, index) in images" :key="index">
                <img :src="image" alt="`Image Uploader ${index}`">
                <div class="flex flex-col text-black text-xs text-left px-4 py-4">
                    <span v-text="files[index].name"></span>
                    <span v-text="getFileSize(files[index].size)"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        inject: ['imageUploaderState'],
        data: () => ({
            isDragging: false,
            dragCount: 0,
            files: [],
            images: [],
            loading: false,
            sharedState: {
                uploaded: false
            }
        }),
        props: ['model', 'id'],
        methods: {
            onDragEnter(e) {
                this.dragCount++;
                this.isDragging = true;
            },
            onDragLeave(e) {
                this.dragCount--;

                if (this.dragCount <= 0)
                    this.isDragging = false;
            },
            onDrop(e) {
                this.isDragging = false;

                const files = e.dataTransfer.files;

                Array.from(files).forEach(file => this.addImage(file));
            },
            onInputChange(e) {
                const files = e.target.files;

                Array.from(files).forEach(file => this.addImage(file));
            },
            addImage(file) {
                if (!file.type.match('image.*')) {
                    this.$toastr.e(`${file.name} is not an image`);
                    return;
                }

                this.files.push(file);

                const reader = new FileReader();

                reader.onload = (e) => this.images.push(e.target.result);

                reader.readAsDataURL(file);
            },
            getFileSize(size) {
                const fSExt = ['Bytes', 'KB', 'MB', 'GB'];
                let i = 0;

                while(size > 900) {
                    size /= 1024;
                    i++;
                }
                return `${(Math.round(size * 100) / 100)} ${fSExt[i]}`;
            },
            upload() {
                this.loading = true;
                const formData = new FormData();

                formData.set('model', this.model);
                formData.set('id', this.id);

                this.files.forEach(file => {
                    formData.append('images[]', file, file.name);
                });

                axios.post('/images/upload', formData)
                    .then(response => {
                        this.$toastr.s('Immagini Caricate con Successo');
                        this.images = [];
                        this.files = [];

                        this.imageUploaderState.uploaded = true;
                        this.loading = false;
                    })
                    .catch(error => {
                        this.loading = false;
                        console.log('Rotto Tutto!');
                    });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .wrapper {
        label,
        input {
            @apply .bg-white .text-blue-400 .w-full .top-0 .left-0 .p-4 .rounded .mt-4 .cursor-pointer;
        }

        input {
            opacity: 0;
            z-index: -2;
        }

        label {
            @apply .absolute;
        }
    }

    .dragging {
        @apply .bg-white .text-blue-400 .border-blue-400;

        div > label {
            @apply .bg-blue-400 .text-white;
        }
    }

    .upload-control {
        label,
        button {
            @apply .bg-blue-400 .text-white .px-6 .py-4 .border-blue-500 .rounded .cursor-pointer;
        }

        label {
            @apply .py-5 .mr-4;
        }
    }

</style>